var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('div',{staticClass:"width100 pa-tb-100 flex f-center f-jcenter"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-center ma-t-40"},[_c('img',{attrs:{"src":require("../img/empty.png"),"alt":"","srcset":"","width":"200"}}),_c('div',{staticClass:"c-999 ma-t-20"},[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }